// extracted by mini-css-extract-plugin
export default {"landingPageOption":"LandingPageOption_landingPageOption__uxv78","header":"LandingPageOption_header__V6Oh6"};